<div class="eod-input mb-0">
<ng-select appendTo="body" class="select-dropdown select-dropdown--sm" [items]="items" bindLabel="value" bindValue="id" [clearable]="false"
    [selectOnTab]="true" [markFirst]="false" [(ngModel)]="value" (change)="onChange($event)">
    <ng-template ng-option-tmp let-item="item" let-index="index">
        <div [class.disabled]="item.isDisabled">
            {{ item.value }}
        </div>
    </ng-template>
</ng-select>
</div>

<!-- <ds-dropdown [dropdownInput]="dropdownConfig">
    <ng-select [items]="items" bindLabel="dropdownName" bindValue="dropdownName" [searchable]="true"
        class="select-dropdown select-dropdown--sm" notFoundText="no data available" name="dropdown">
    </ng-select>
</ds-dropdown> -->